/**
 * Cart Goal
 */

function cartGoal() {
  
  setTimeout(function() {
    var cartContents = fetch('/cart.js').then(response => response.json()).then(data => { 

      if (data.item_count == 0) {
        document.querySelector('.cart_goal').style.display = "none";
        /* Gute Wahl */
        //document.querySelector(".drawer-banner").classList.remove("visible");
      }
      else {
        document.querySelector('.cart_goal').style.display = "block";
        /* Gute Wahl */
        //document.querySelector(".drawer-banner").classList.add("visible");
      }

      if (data.currency == 'EUR') {
        var symbol = '€';
      }
      var cart_total = data.total_price;
      var cart_totaltoText = cart_total.toString(); //convert to string
      cart_total = cart_totaltoText.slice(0, -2);
      cart_total = +(cart_total);
      var lastChar = cart_totaltoText.slice(-2); //gets last character
      var lastDigit = +(lastChar); //convert last character to number
      if (lastDigit > 0) {
        cart_total = cart_total + 1;
      }

      var percentage_reached = (cart_total * 100) / goal;
      var goal_1 = goal - cart_total;
      if (percentage_reached > 100) {
        percentage_reached = 100;
        document.querySelector('.shipping_bar').setAttribute("style","width:" + percentage_reached + "%");
        document.querySelector('.cg-free-shipping-text').innerHTML = '<span>' + goal_reached_text + '</span>';
      } else {
        document.querySelector('.shipping_bar').setAttribute("style","width:" + percentage_reached + "%");
        document.querySelector('.cg-free-shipping-text').innerHTML = '<span>' + goal_before_text + ' <span class="cg-goal-amount">' + goal_1 + symbol + '</span> ' + goal_after_text + '</span>';
      }

    });
  }, 100);
}

var goal, goal_before_text, goal_after_text, goal_reached_text;

document.addEventListener('page:loaded', function() {
  
  goal = document.querySelector('.dbtfy-cart_goal.active_goal').getAttribute('data-goal-amount');
  goal_before_text = document.querySelector('.dbtfy-cart_goal.active_goal').getAttribute('data-before-amount-text');
  goal_after_text = document.querySelector('.dbtfy-cart_goal.active_goal').getAttribute('data-after-amount-text');
  goal_reached_text = document.querySelector('.dbtfy-cart_goal.active_goal').getAttribute('data-goal-reached-text');
  
  /*cart goal start*/
  if (document.querySelector('.dbtfy.dbtfy-cart_goal').classList.contains('active_goal')) {
    
    cartGoal();
    
    document.addEventListener('cart:updated', function(evt) {
	  cartGoal();
    });
  }
  /*cart goal end*/

});


/**
 * Teeinblue
 */

TeeInBlue = {
  recustomizeButtonText: 'Bild anpassen',
  debug: false,
};

// open side cart after teeinblue add to cart
document.addEventListener('teeinblue-event-after-cart-added', function() {
  
  // redirect to cart page
//   window.location.href = "https://pfotengut.de/cart";
  console.log('added')
  document.dispatchEvent(new Event("ajaxProduct:added"));
  cartGoal();
  
  /* GTM 
  dataLayer.push({'event':'gtmATC'});*/
});

/**
 * Produktseite Lieferzeit berechnen
 */

window.onload = function() {
  
  /*
   * Lieferzeit Berechnung
   */
  
  // array of ISO YYYY-MM-DD format dates
  publicHolidays = {
      ger:["2024-12-25", "2024-12-26"]
  }
  // check if there is a match in the array
  Date.prototype.isPublicHoliday = function( data ){// we check for a public holiday
      if(!data) return 1;
  return data.indexOf(this.toISOString().slice(0,10))>-1? 0:1;
  }

  // calculation of business days
  Date.prototype.businessDays = function( d, holidays ){
      var holidays = holidays || false, t = new Date( this ); // copy date.
      while( d ){ // we loop while d is not zero...   
          t.setDate( t.getDate() + 1 ); // set a date and test it
          switch( t.getDay() ){ // switch is used to allow easier addition of other days of the week
              case 0: break;// sunday
              default: // check if we are a public holiday or not
                  d -= t.isPublicHoliday( holidays ); 
          }
      }
      return t; // just the YYY-MM-DD 
  }

  // today date as order date
  var OrderDate = new Date();
  
  var fromDeliveryDate = OrderDate.businessDays(6, publicHolidays.ger);
  var toDeliveryDate = OrderDate.businessDays(14, publicHolidays.ger);

  var allMonths = ['Jan', 'Feb', 'Mar', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'];

  // FROM DATE
  var fromDeliveryMonth = fromDeliveryDate.getMonth(); // month (in integer 0-11)
  fromDeliveryMonth = allMonths[fromDeliveryMonth];
  var fromDeliveryDay = fromDeliveryDate.getDate(); // day 0-31

  // TO DATE
  var toDeliveryMonth = toDeliveryDate.getMonth(); // month (in integer 0-11)
  toDeliveryMonth = allMonths[toDeliveryMonth];
  var toDeliveryDay = toDeliveryDate.getDate(); // day 0-31


  // element to write date to  
  var lieferdatum = document.getElementById("lieferdatum");
  if(lieferdatum) {
  		lieferdatum.innerHTML = "Lieferung zwischen <span class='delivery-date'>" + fromDeliveryDay + ". "+ fromDeliveryMonth + 
    "</span> und <span class='delivery-date'>" + toDeliveryDay + ". "+ toDeliveryMonth + "</span>"; // nach 🇩🇪/🇦🇹
  }
  
};

/**
 * Menü Switcher
 */
document.addEventListener('page:loaded', function() {
  var tabsNav = document.querySelectorAll('.tabsNav');
  tabsNav.forEach(function(el) {
    let attrLinked = el.dataset.control;
    let tabsNavLinks = el.querySelectorAll('.tabsNavLink, .tabsPicLink');
    tabsNavLinks.forEach(function(el) {
      el.addEventListener('click', function(e) {
        let href = el.getAttribute('href');
        let controledTabs = document.querySelectorAll(attrLinked + ' .tabsNavTab');
        let tabToOpen = document.querySelector(attrLinked + ' .tabsNavTab' + href);
        e.preventDefault();
        tabsNavLinks.forEach(function(lnk) {
          lnk.classList.remove('is-active');
        });
        controledTabs.forEach(function(tab) {
          tab.classList.remove('is-open');
        });
        el.classList.add('is-active');
        tabToOpen.classList.add('is-open');
      })
    });
  });
});

/* add to cart tracking 
document.addEventListener('ajaxProduct:added', function(evt) {
  console.log("add to")
  obApi('track', 'Add To Cart');
}); */
